import { IMaterialAvatarData } from '../types/material';
import { EAvatarTag } from '../types/npcBase';

export function extractBaseImgFromMaterial(material: IMaterialAvatarData) {
  const item = material.avatar_info?.avatar_list?.find((s) => s.avatar_tag === EAvatarTag.BaseImg);
  return item?.avatar_img_url || '';
}

export function extractBaseAvatarFromMaterial(material: IMaterialAvatarData) {
  return material.avatar_info?.avatar_list?.find((s) => s.avatar_tag === EAvatarTag.BaseImg);
}

export function extractUserUploadAvatarFromMaterial(material: IMaterialAvatarData) {
  return material.avatar_info?.avatar_list?.find((s) => s.avatar_tag === EAvatarTag.UserUploadImg);
}

export function combineAvatarFromMaterial(material: IMaterialAvatarData) {
  const baseAvatar = extractBaseAvatarFromMaterial(material) || {};
  const userUploadAvatar = extractUserUploadAvatarFromMaterial(material) || {};
  return { ...baseAvatar, img_desc: userUploadAvatar?.img_desc || baseAvatar?.img_desc };
}
